import { render } from "./ProductImageZoom.vue?vue&type=template&id=ef6d443a&scoped=true"
import script from "./ProductImageZoom.vue?vue&type=script&lang=js"
export * from "./ProductImageZoom.vue?vue&type=script&lang=js"

import "./ProductImageZoom.vue?vue&type=style&index=0&id=ef6d443a&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6d443a"]])

export default __exports__